/* eslint-disable react/display-name */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ITab, ITabs } from '../../types/customizer';
import './index.scss';
import { getRowContent, REQUIRED_TAB_FIELDS, TABS_TO_AVOID } from '../Summary';

type PrintProps = {
  tabs: ITabs;
  product: any;
  image: string;
  pathPrefix?: string;
};

const PrintSummary = React.forwardRef((props: PrintProps, ref) => {
  const { tabs, product, image, pathPrefix } = props;

  const imageStr = `${process.env.REACT_APP_ASSET_URL}${image}`;
  const imageURL = `${imageStr}${imageStr.indexOf('?') !== -1 ? '&' : '?'}image_size=1200`;

  const handleKeyDown = (event: KeyboardEvent) => {
    const printButton = document.getElementById('print-btn');

    if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && printButton) {
      event.preventDefault();
      printButton.click();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const REQUIRED_TABS = tabs.filter((tab: ITab) => REQUIRED_TAB_FIELDS.includes(tab.eventKey));
  const ADDITIONAL_TABS = tabs.filter(
    (tab: ITab) => !REQUIRED_TAB_FIELDS.includes(tab.eventKey) && !TABS_TO_AVOID.includes(tab.eventKey)
  );
  return (
    // @ts-ignore
    <div ref={ref} className="print-summary tw-py-10 tw-px-4 tw-text-prussian-blue tw-mx-auto tw-w-[calc(100%-2cm)]">
      <div className="tw-mb-4 tw-flex tw-justify-center">
        <img className="tw-h-[285px]" src={imageURL} alt="" />
      </div>
      <p>{product?.description}</p>
      <div className="tw-mt-3 tw-text-lg tw-font-bold">Required</div>
      <div className="print-summary-container tw-mt-3">
        <div>
          <p>Ring Category Sku</p>
          <p>{product?.helzberg_custom_sku}</p>
        </div>
        <div className="tw-mt-1">
          <p>REFERENCE CODE</p>
          <p>{product.magic_number}</p>
        </div>
        {REQUIRED_TABS.map((tab: ITab, index) => (
          <React.Fragment key={index}> {getRowContent(tab, index)}</React.Fragment>
        ))}
      </div>

      <div className="tw-mt-3 tw-text-lg tw-font-bold">Additional Details</div>
      <div className="print-summary-container tw-mt-3">
        {ADDITIONAL_TABS.map((tab: ITab, index) => (
          <React.Fragment key={index}> {getRowContent(tab, index)}</React.Fragment>
        ))}
      </div>
      <div className="tw-mt-3 tw-text-lg tw-font-bold">Price Details</div>
      <div className="print-summary-container tw-mt-3">
        <div className="tw-mt-1">
          <p>Ring Price</p>
          <p>{product?.price}</p>
        </div>
      </div>
      <div className="tw-text-right tw-mt-20">Signature: _________________________</div>
    </div>
  );
});

const mapStateToProps = (state: any) => ({
  product: state.customizer.product
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(PrintSummary);
